// get api methods
export {getMethod} from "./getMethod";
// delete api methods
export { deleteMethod } from './deleteMethod';
// post api methods
export {postMethod} from './postMethod';
// put api methods
export {putMethod} from './putMethod';
export {putMethodFile} from './putMethodFile';

// post api methods for files
export {postMethodFile } from "./postMethodFile";
